import { render, staticRenderFns } from "./ReleaseCard.vue?vue&type=template&id=4c4381e9&"
import script from "./ReleaseCard.vue?vue&type=script&lang=js&"
export * from "./ReleaseCard.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseCard.vue?vue&type=style&index=0&id=4c4381e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports